import { DropdownModel } from '@shared/models/dropdown-model.model';
import { Expose } from 'class-transformer';
import { RCustomerLookupEntityType } from '@shared-features/enums/shared-enums.enum';
import { OrderType } from '@shared-features/enums/order-type.enum';
import { DefinitionOrderTemperatureControl } from '@shared-features/enums/definition-order-temperature-control.enum';

export class Lookup extends DropdownModel {
  @Expose() id: number;
  @Expose() value: string;
  // extra props
  @Expose() cityId?: number;
  @Expose() fleet?: number;
  @Expose() numofpallets?: number;

  // extra props for r customers lookup in add shipment
  @Expose()
  type?: RCustomerLookupEntityType;

  // extra props for locations
  @Expose()
  isDefault?: boolean;

  @Expose()
  sku?: string; // FOR PRODUCT TYPE ITEMs
  @Expose()
  notes?: string; // FOR PRODUCT TYPE ITEMs
  @Expose()
  productTypeName?: string;

  @Expose() get dropDownDisplayName(): string {
    return this.value;
  }

  @Expose() get dropDownValue(): Lookup {
    return this;
  }

  // for order lookup and it will removed when we handle return the full object of lookup
  @Expose() dropOffLocationTitle?: string;
  @Expose() dropOffLocationId?: number;
  @Expose() isPalletDetails?: boolean;
  @Expose() noOfItems?: number;
  @Expose() noOfPallets?: number;
  @Expose() orderType?: OrderType;
  @Expose() priority?: number;
  @Expose() reference?: string;
  @Expose() remainingQuantity?: number;
  @Expose() rush?: boolean;
  @Expose() sealNumber?: number;
  @Expose() temperatureControl?: DefinitionOrderTemperatureControl;
  @Expose() createdAt?: Date;
  @Expose() polygonCoordinates?: string;
  @Expose() isEnabled?: boolean;
  @Expose() fromCityId?: number;
  @Expose() fromCityName?: string;
  @Expose() toCityId?: number;
  @Expose() toCityName?: string;
  @Expose() truckTypeIds?: number[];
  @Expose() imageUrl?: string;
}
